import { hexOfSha256, sortObjectByKeys } from '../helpers';

export const generateBoltSignatureHeader = (
    payload: { [key: string]: any },
    timestamp: number,
    method: 'GET' | 'POST' | 'PUT' | 'DELETE'
): string => {
    return hexOfSha256(JSON.stringify(sortObjectByKeys(payload)) + ':' + timestamp + ':' + method);
};

export const getBucketIdFromAccountId = (accountId: number) => {
    return (accountId >>> 9) + (accountId & 0x1ff);
};
